
import { createClient } from '@supabase/supabase-js';

// Configuration for the Supabase Client
// These keys should be replaced with your specific project details from https://supabase.com/dashboard
const SUPABASE_URL = process.env.SUPABASE_URL || 'https://sokndwwxyxeyziyidpla.supabase.co';
const SUPABASE_KEY = process.env.SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNva25kd3d4eXhleXppeWlkcGxhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ3Mjg2MjMsImV4cCI6MjA4MDMwNDYyM30.CxtR2YKF5Pmh06yfDB3qqQleaWFeynDkmLaEWDux5k8';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
